import CryptoJS from "crypto-js"

function generateCodeVerifier() {
    return generateRandomString(96);
}

function generateRandomString(length) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

function generateCodeChallenge(code_verifier) {
    return CryptoJS.SHA256(code_verifier);
}

function base64URL(string) {
    return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const verifier = () =>{
    return base64URL(generateCodeVerifier());
} 

export const challenge = (verifier) =>{
   return  base64URL(generateCodeChallenge(verifier));
}